<template>
    <div>
        <div class="form-actions flex justify-between py-0">
            <div class="flex vx-col-action">
                <vs-input icon-pack="feather" icon="icon-search" placeholder="Type here..." v-model="globalSearchTerm" class="is-label-placeholder searchBar-input" id="filter-text-box" v-on:input="onFilterTextBoxChanged()" />
                <span class="br-line-long mr-2 ml-2"></span>
            </div>

            <div class="float-right flex">
                <span class="br-line-long mr-2 ml-2"></span>

                <vx-tooltip text="Download List" position="top">
                    <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-download" @click="downloadData()"></vs-button>
                </vx-tooltip>

                <vx-tooltip text="Reset Filters" position="top">
                    <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshPageWithFilters()"></vs-button>
                </vx-tooltip>
            </div>
        </div>

        <div id="grid-loader" class="vx-card vs-con-loading__container">
            <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :components="components" :rowData="tableData" rowSelection="multiple" :enableRangeSelection="true" :suppressCopyRowsToClipboard="true" :suppressDragLeaveHidesColumns="true" :animateRows="false" :floatingFilter="true" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" :suppressRowClickSelection="true" :rowClassRules="rowClassRules" :statusBar="statusBar" :sideBar="sideBar" :rowHeight="35" :headerHeight="30" :floatingFiltersHeight="45" :checkboxSelection="true" @filter-changed="onFilterChanged" @row-selected="onRowSelected" @pagination-changed="onPaginationChanged" @column-resized="onColumnResized">
            </ag-grid-vue>
            <div class="vx-row py-5">
                <div class="vx-col w-full">
                    <vs-pagination :total="totalPages" :max="maxPageNumbers" class="custom-pagination" v-model="currentPage" />
                </div>
            </div>
        </div>

        <AddCustomList></AddCustomList>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

import AddCustomList from "@/components/rebates/AddCustomList.vue";

export default {
    name: "QueuedCustomLists",
    components: {
        AgGridVue,
        AddCustomList,
    },
    data() {
        return this.initData();
    },
    watch: {
        windowWidth(val) {
            // Toggle colummn movable
            this.toggleColumnMovable(val);
            // Toggle colummn pinning
            this.toggleColumnPinned(val);
        },
    },
    computed: {
        windowWidth: function () {
            return this.$store.state.windowWidth;
        },
        user_role() {
            return JSON.parse(localStorage.getItem("userDetails")).role;
        },
        user_id() {
            return JSON.parse(localStorage.getItem("userDetails")).id;
        },
        status() {
            return event.node;
        },
        paginationPageSize() {
            if (this.gridApi) {
                return this.gridApi.paginationGetPageSize();
            } else {
                return 15;
            }
        },
        totalPages() {
            if (this.gridApi) {
                return this.gridApi.paginationGetTotalPages();
            } else {
                return 0;
            }
        },
        scrollbarTag() {
            return this.$store.getters.scrollbarTag;
        },
        currentPage: {
            get() {
                if (this.gridApi)
                    return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
            },
        },
    },
    methods: {
        initData() {
            return {
                selectedRowCount: "",
                gridOptions: {},
                maxPageNumbers: 7,
                gridApi: null,
                defaultColDef: {
                    sortable: true,
                    resizable: true,
                    suppressMenu: true,
                    suppressMovable: false,
                    filterParams: {
                        suppressAndOrCondition: true,
                        newRowsAction: "keep",
                    },
                },
                rowClassRules: null,
                statusBar: null,
                sideBar: null,
                columnDefs: null,
                tableData: null,
                selectedPromos: [],
                // Cell Renderer Components
                components: {
                    // CellRendererStatus,
                },
                globalSearchTerm: "",
                flags: {
                    // selectedAll: false,
                    selectedAll: [],
                },
            };
        },
        onPageSizeChanged() {
            var value = document.getElementById("page-size").value;
            this.gridApi.paginationSetPageSize(Number(value));
        },
        onPaginationChanged() {
            if (this.gridApi) {
                (this.totalRows = this.gridApi.paginationGetRowCount()),
                    (this.currentPageSize =
                        this.gridApi.paginationGetPageSize());
            }
        },
        onRowSelected(event) {
            var getStatus = this.gridApi
                .getSelectedNodes()
                .map((x) => x.data)
                .map((x) => x.status);
            // FIXME: Change Non editable condition according to rebates requirement
            getStatus.includes("expired")
                ? (this.selectedNonEditableRow = true)
                : (this.selectedNonEditableRow = false);
            if (event.node.selected) {
                // Push to selectedPromos
                this.selectedRowCount = this.gridApi.getSelectedNodes().length;
                if (this.selectedRowCount > 30) {
                    event.node.setSelected(false);

                    this.$vs.notify({
                        time: 5000,
                        color: "warning",
                        title: "Warning",
                        text: "You may select only upto 30 rows",
                    });
                }
            } else {
                this.selectedRowCount = this.gridApi.getSelectedNodes().length;
            }
        },
        onFilterChanged() {
            this.deselectAllSelectedRows();
        },
        openLoadingInDiv() {
            this.$vs.loading({
                container: "#div-with-loading",
                scale: 0.8,
            });
        },
        hideLoadingInDiv() {
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        },
        populateTableData() {
            let self = this;

            /* Get table data */
            this.$axiosSecure
                .get("/rebates/custom-list/scheduled")
                .then((response) => {
                    this.tableData = response.data.data;

                    if (this.gridApi) {
                        setTimeout(() => {
                            this.initSelectedAllFlag();
                        }, 1000);
                    }
                })
                .catch((error) => {
                    // Error notification
                    self.$vs.notify({
                        color: "danger",
                        title: "Something went wrong",
                        text: "Please contact the server admin",
                    });

                    console.log(error);

                    // Clear Listing Count
                    this.$store.dispatch("clearListingCount");
                });
        },
        toggleColumnMovable(val) {
            if (val <= 576) {
                this.defaultColDef["suppressMovable"] = true;
            } else {
                this.defaultColDef["suppressMovable"] = false;
            }
        },
        toggleColumnPinned(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("domain", null);
            } else {
                this.gridOptions.columnApi.setColumnPinned("domain", "left");
            }
        },
        onColumnResized() {
            this.gridApi.resetRowHeights();
        },
        sizeColumnsToFit() {
            this.gridApi.sizeColumnsToFit();
        },
        disableQueue() {
            this.rowClassRules = {
                "ag-row-disabled": 'data && (data.status == "edit pending")',
                "ag-checkbox-disabled":
                    'data && (data.status == "edit pending")',
                // "ag-row-red": 'data && (data.status == "expired")',
            };
        },
        // Refresh the page withou resetting filters
        refreshPage() {
            this.initSelectedAllFlag();
            // Reset selection
            this.gridApi.deselectAll();
            // Reset sort
            this.gridApi.setSortModel(null);
            // Table Data AXIOS Call
            this.populateTableData();
        },
        // With filters for when we want to reset filters
        refreshPageWithFilters() {
            this.initSelectedAllFlag();
            // Reset filters
            this.gridApi.setFilterModel(null);
            // Reset selection
            this.gridApi.deselectAll();
            // Reset sort
            this.gridApi.setSortModel(null);
            // Table Data AXIOS Call
            this.populateTableData();
        },
        gridSelectAll() {
            this.gridApi.forEachNodeAfterFilter((node) => {
                if (
                    !(
                        node.data.status == "new approved" ||
                        node.data.status == "rejected" ||
                        node.data.status == "error"
                    )
                ) {
                    if (
                        node["rowIndex"] >=
                            (this.currentPage - 1) *
                                this.gridApi.paginationGetPageSize() &&
                        node["rowIndex"] <
                            this.currentPage *
                                this.gridApi.paginationGetPageSize()
                    ) {
                        node.setSelected(true);
                    }
                }
            });
        },
        gridDeselectAll() {
            this.gridApi.forEachNodeAfterFilter((node) => {
                if (
                    node["rowIndex"] >=
                        (this.currentPage - 1) *
                            this.gridApi.paginationGetPageSize() &&
                    node["rowIndex"] <
                        this.currentPage * this.gridApi.paginationGetPageSize()
                ) {
                    node.setSelected(false);
                }
            });
        },
        addCustomList() {
            // TODO: Open Add Custom List popup
            this.$root.$emit("openAddCustomList");
        },
        editCustomList() {
            // TODO: Add API to manually edit Scheduled Rebates
        },
        deleteCustomList() {
            // TODO: Add function to delete Scheduled Rebates
        },
        downloadData() {
            // TODO: Add function for download of data
            this.$root.$emit("downloadCustomLists");
        },
        toggleSelectAll() {
            if (this.flags["selectedAll"][this.currentPage - 1]) {
                this.gridDeselectAll();
                this.flags["selectedAll"][this.currentPage - 1] =
                    !this.flags["selectedAll"][this.currentPage - 1];
            } else {
                this.selectedRowCount = this.gridApi.getSelectedNodes().length;
                if (
                    this.selectedRowCount < 30 &&
                    this.selectedRowCount + 15 <= 30
                ) {
                    this.gridSelectAll();
                    this.flags["selectedAll"][this.currentPage - 1] =
                        !this.flags["selectedAll"][this.currentPage - 1];
                } else {
                    this.$vs.notify({
                        time: 5000,
                        color: "warning",
                        title: "Warning",
                        text: "You may select only upto 30 rows",
                    });
                }
            }
        },
        onFilterTextBoxChanged() {
            this.gridApi.setQuickFilter(
                document.getElementById("filter-text-box").value
            );
            this.deselectAllSelectedRows();
        },
        initSelectedAllFlag() {
            if (this.tableData.length) {
                for (
                    let i = 0;
                    i < this.gridApi.paginationGetTotalPages();
                    i++
                ) {
                    this.flags["selectedAll"].push(false);
                }
            }
        },
        deselectAllSelectedRows() {
            this.gridApi.deselectAll();

            this.flags["selectedAll"].fill(false);
        },
    },
    beforeMount() {
        this.disableQueue();

        // Table Data AXIOS Call
        this.populateTableData();

        // Reset movable columns on mobile
        this.toggleColumnMovable(this.windowWidth);

        (this.columnDefs = [
            {
                headerName: "Partner Name",
                field: "new_registar.unique_registar",
                filter: "agSetColumnFilter",
                minWidth: 280,
                width: 250,
                pinned: "left",
                cellRenderer: (data) => {
                    return this.toTitleCase(data.data.new_registrar.unique_registrar.name);
                }
            },
            {
                headerName: "Domain Name",
                field: "domain_name",
                filter: "agTextColumnFilter",
                minWidth: 130,
                cellRenderer: (data) => {
                    return this.toTitleCase(data.data.domain_name);
                }
            },
            {
                headerName: "Price",
                field: "price",
                filter: "agTextColumnFilter",
                minWidth: 130
            },
            {
                headerName: "TLD",
                field: "tld.tld_name",
                filter: "agTextColumnFilter",
                minWidth: 130,
            },
        ]),
            // Set Grid sidebar
            (this.sideBar = {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel",
                        toolPanelParams: {
                            suppressRowGroups: true,
                            suppressValues: true,
                            suppressPivots: true,
                            suppressPivotMode: true,
                            suppressSideButtons: true,
                            suppressColumnSelectAll: true,
                            suppressColumnExpandAll: true,
                        },
                    },
                ],
            });
    },
    mounted() {
        this.gridApi = this.gridOptions.api;

        //agigrid loader
        this.gridApi.showLoadingOverlay();

        // Resize to fit columns
        this.sizeColumnsToFit();

        // Reset pinned columns on mobile
        this.toggleColumnPinned(this.windowWidth);

        // Bind Download Data Event Listeners
        this.$root.$on("downloadCustomLists", () => {
            var params = {
                onlySelected: true
            }

            this.gridApi.exportDataAsCsv(params);
        });

        // Bind Button Event Listeners
        this.$root.$on("tableRefresh", () => {
            this.refreshPage();
        });
    },
    destroyed() {
        // Clear Listing Count
        this.$store.dispatch("clearListingCount");

        // Unbind Button Event Listeners
        this.$root.$off("downloadCustomLists");
        this.$root.$off("tableRefresh");
    },
};
</script>